import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout'

Vue.use(Router);

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    noCache: true                // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
    requireLogin: true           // 如果设置为true，则前往此页面未登录时会跳转至登录页
  }
 */

export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        redirect: 'index',
        children: [
            {
                path: 'login',
                component: () => import('../views/login'),
                name: '登录',
                meta: {title: '登录', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'index',
                component: () => import('../views/main'),
                name: '首页',
                meta: {title: '首页', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'about',
                component: () => import('../views/index'),
                name: '关于我们',
                meta: {title: '关于我们', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'job',
                component: () => import('../views/job'),
                name: '人才大厅',
                meta: {title: '人才大厅', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'project',
                component: () => import('../views/project'),
                name: '项目咨询',
                meta: {title: '项目咨询', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'studio',
                component: () => import('../views/studio'),
                name: '工作室',
                meta: {title: '工作室', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'jobList',
                component: () => import('../views/jobList'),
                name: '更多职位',
                meta: {title: '更多职位', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'authentication',
                component: () => import('../views/authentication'),
                name: '企业认证',
                meta: {title: '企业认证', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                hidden: true,
                path: 'jobdetails/:jobId(\\d+)',
                component: () => import('../views/jobDetails'),
                name: '职位详情',
                meta: {title: '职位详情', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                hidden: true,
                path: 'companyDetails/:companyId(\\d+)',
                component: () => import('../views/companyDetails'),
                name: '企业详情',
                meta: {title: '企业详情', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                path: 'userCenter',
                component: () => import('../views/userCenter'),
                name: '个人中心',
                meta: {title: '个人中心', icon: 'dashboard', noCache: true, affix: true},
                children: [
                    {
                        path: '/userPortrait',
                        component: () => import('../views/userCenter/components/UserPortrait'),
                        name: '用户画像',
                        meta: {title: '用户画像', icon: 'dashboard', noCache: true, affix: true}
                    },
                    {
                        path: '/myResume',
                        component: () => import('../views/userCenter/components/Resume'),
                        name: '我的简历',
                        meta: {title: '我的简历', icon: 'dashboard', noCache: true, affix: true}
                    },
                    {
                        path: '/myApplyFor',
                        component: () => import('../views/userCenter/components/ApplyFor'),
                        name: 'ApplyFor',
                        meta: {title: '我的应聘', icon: 'dashboard', noCache: true, affix: true}
                    },
                    {
                        path: '/collection',
                        component: () => import('../views/userCenter/components/Collection'),
                        name: 'Collection',
                        meta: {title: '我的收藏', icon: 'dashboard', noCache: true, affix: true}
                    },
                    // {
                    //     path: '/account',
                    //     component: () => import('../views/userCenter/Account'),
                    //     name: '账号设置',
                    //     meta: {title: '账号设置', icon:'dashboard', noCache: true, affix: true}
                    // }
                ]
            },
            {
                path: 'projectApplication',
                component: () => import('../views/projectApplication'),
                name: '项目申请',
                meta: {title: '项目申请', icon: 'dashboard', noCache: true, affix: true, requireLogin: true}
            },
            {
                hidden: true,
                path: 'moreResume',
                component: () => import('../views/moreResume'),
                name: '更多人才',
                meta: {title: '更多人才', icon: 'dashboard', noCache: true, affix: true}
            },
            {
                hidden: true,
                path: 'moreResume/detail/:id(\\d+)',
                component: () => import('../views/moreResume/ResumeDetail'),
                name: '简历详情',
                meta: {title: '简历详情', icon: 'dashboard', noCache: true, affix: true}
            },
        ]
    }
];

export default new Router({
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})
